import Vue from "vue";
import App from "./App.vue";
import { router } from "./router";
import store from "./store";

//THIRD PARTY ADDONS & PLUGINS

//Template vendors
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import "font-awesome/css/font-awesome.min.css";

import "./assets/vendor/nucleo/css/nucleo.css";

import "./assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";

import moment from "moment";
moment.locale("es");
import Axios from "axios";
Axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;

import underscore from "vue-underscore";
Vue.use(underscore);

Vue.use(require("vue-moment/dist/vue-moment.es"));

require("toastr/toastr.scss");

import "toastmejs/dist/css/toastme.css";

require("sweetalert2/dist/sweetalert2.css");

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

import bPagination from "bootstrap-vue/es/components/pagination/pagination";
Vue.component("b-pagination", bPagination);

import VuePaginate from "vue-paginate";
Vue.use(VuePaginate);

import bModal from "bootstrap-vue/es/components/modal/modal";
Vue.component("b-modal", bModal);

import bButton from "bootstrap-vue/es/components/button/button";
Vue.component("b-button", bButton);

import bTabs from "bootstrap-vue/es/components/tabs/tabs";
Vue.component("b-tabs", bTabs);

import bTab from "bootstrap-vue/es/components/tabs/tab";
Vue.component("b-tab", bTab);

import VueGoodWizard from "vue-good-wizard";
Vue.use(VueGoodWizard);

import vSelect from "vue-select";
Vue.use(vSelect);
Vue.component("vSelect", vSelect);

import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";
Vue.use(VeeValidate);
Validator.localize("es", es);

import VueFlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/material_blue.css";
Vue.use(VueFlatPickr);

import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

//Resources
//import './assets/js/frontend.js'
import "bootstrap/scss/bootstrap.scss";
import "./assets/scss/app.scss";

//GLOBAL COMPONENTS
import _sidebar from "./components/layout/_sidebar";
import _navbar from "./components/layout/_navbar";
import _footer from "./components/layout/_footer";
import _spinner from "./components/layout/_spinner";
import _searchDealer from "./components/general/SearchDealer";

Vue.component("MySidebar", _sidebar);
Vue.component("MyNavbar", _navbar);
Vue.component("MyFooter", _footer);
Vue.component("MySpinner", _spinner);

Vue.component("SearchDealer", _searchDealer);

Vue.config.productionTip = false;

Vue.config.ignoredElements = [
    'cs-fb-leads-integration',
    'latam-plugin-cs'
];

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");